import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { IntlProvider } from 'react-intl';

import Store from '../store';
import UserStore from '../store/userStore';

import { determineLocale, setUpForLocale } from './locales';

interface Props {
  children: React.ReactNode;
  userStore: UserStore;
}

interface State {
  locale?: string;
  messages: { [key: string]: string };
}

@observer
class UchiIntlProvider extends React.Component<Props, State> {
  state = {
    locale: undefined,
    messages: {},
  };

  componentDidMount(): void {
    when(
      () => this.props.userStore.hasLoaded,
      () => {
        const locale = determineLocale(this.props.userStore.locale);
        setUpForLocale(locale).then(messages => {
          this.setState({
            locale,
            messages,
          });
        });
      },
    );
  }

  render() {
    const { locale, messages } = this.state;
    if (!locale) {
      return null;
    }
    return (
      <IntlProvider locale={locale} messages={messages}>
        <React.Fragment>{this.props.children}</React.Fragment>
      </IntlProvider>
    );
  }
}

export default inject(({ userStore }: Store) => ({ userStore }))(UchiIntlProvider);
